<div class="chart-container-inner">
  <highcharts-chart [Highcharts]="highcharts" [options]="chartOptions" [constructorType]="chartConstructor"
    [(update)]="updateFlag">
  </highcharts-chart>
  <alert type="info" id="rec-grades-info">{{'analysis.recyclabilityAnalysis.infoRecGrades' | translate}}</alert>
</div>
